import { required, requiredIf, numeric, minLength, maxLength, sameAs, minValue, maxValue } from 'vuelidate/lib/validators'

const phoneNumber = value => {
  return value.replace(/[+\s]/g, '').length === 12
}

export const formLogin = {
  login: { required, numeric },
  password: { required }
}

export const addPhone = {
  phone: { phoneNumber },
  code: { required, minLength: minLength(6) }
}

export const addPhoneModal = step => ({
  phone: {
    required: requiredIf(() => step === 'addPhone'),
    phoneNumber
  },
  code: {
    required: requiredIf(() => step === 'enterCode'),
    minLength: minLength(6)
  }
})

export const formCode = activeType => ({
  name_device: { required },
  type_device: { required },
  mac_address: { required: requiredIf(() => activeType === 'mac'), minLength: minLength(17) },
  code: { required: requiredIf(() => activeType === 'code'), numeric, minLength: minLength(4) }
})

export const tvTariffPasswordChange = {
  password: { required, minLength: minLength(6), maxLength: maxLength(16) },
  passwordConfirmation: { required, sameAsPassword: sameAs('password') }
}

export const createPayment = {
  price: {
    required,
    numeric,
    minValue: minValue(process.env.VUE_APP_DEV_MODE === 'true' ? 1 : 30),
    maxValue: maxValue(9999)
  },
  paymentSystem: { required }
}
